import React from "react";
import classNames from "classnames";
import { Line, LineChart, ResponsiveContainer } from "recharts";
import { IVDMAlert } from "redux/app/vdmdashboard/@types";


// const smartAlerts: IVDMAlert[] = [
// 	{
// 		title: "Alert 001",
// 		value: 2000,
// 		percentageChange: 20,
// 		chartData: [
// 			{ value: 100 },
// 			{ value: 300 },
// 			{ value: 200 },
// 			{ value: 400 },
// 			{ value: 500 },
// 		],
// 		change: "UPWARDS",
// 		actionLink: "",
// 	},
// 	{
// 		title: "Alert 002",
// 		value: 3000,
// 		percentageChange: 10,
// 		chartData: [
// 			{ value: 500 },
// 			{ value: 300 },
// 			{ value: 300 },
// 			{ value: 400 },
// 			{ value: 100 },
// 		],
// 		change: "DOWNWARDS",
// 		actionLink: "",
// 	},
// ];



const CustomDot = (props: any) => {
	const { cx, cy, chartColor } = props; // index, data can also be used if required

	return (
		// Render a SVG circle with a white fill and red stroke
		<svg
			x={cx - 5}
			y={cy - 5}
			width="10"
			height="10"
			fill="white"
			viewBox="0 0 10 10"
		>
			<circle
				cx="5"
				cy="5"
				r="4"
				stroke={chartColor || "#EF4444"}
				strokeWidth="2"
				fill="white"
			/>
		</svg>
	);
};

type OwnProps = {
	smartAlerts?: IVDMAlert[] 
};
type AlertsSidebarContentProps = OwnProps;
function AlertsSidebarContent(props: AlertsSidebarContentProps) {
	const { smartAlerts } = props;
	return (
		<div >
			{smartAlerts?.length ? smartAlerts?.map((alertCard,index) => {
				const { title, value, percentageChange, change, chartData } = alertCard;
				return (
					<div key={title + change + index} className="bg-white shadow-md border rounded-lg mt-4 w-full max-w-sm">
						<div className=" p-6 pb-0">
							{/* Left side */}
							<div className="flex justify-between items-start mb-4">
								<div className="flex-1 pr-4">
									<p className="text-[12px] text-gray-500">{title}</p>

									<p className="text-lg font-medium text-gray-800 my-2">
										{value?.toLocaleString()}
									</p>

									<div className="flex items-center text-sm text-red-500">
										<span
											className={classNames("bp3-icon text-red-500", {
												"bp3-icon-arrow-up": change === "UPWARDS",
												"bp3-icon-arrow-down": change === "DOWNWARDS",
											})}
										/>
										<span>{percentageChange}%</span>

										{percentageChange && (
											<span className="ml-1 text-gray-500">of range</span>
										)}
									</div>
								</div>

								{/* Right Side: Chart */}

								<div className="w-2/5 h-20 -mt-2 -mr-2">
									<ResponsiveContainer width="100%" height="100%">
										<LineChart
											data={chartData}
											margin={{ top: 10, right: 5, left: 5, bottom: 5 }}
										>
											<Line
												type="linear"
												dataKey="value"
												stroke={"#f87171"}
												strokeWidth={2.5}
												dot={(props) => (
													<CustomDot
														{...props}
														chartColor={"#f87171"}
														data={chartData}
													/>
												)}
												isAnimationActive={false}
												activeDot={false}
											/>
										</LineChart>
									</ResponsiveContainer>
								</div>
							</div>
						</div>

						<div className="border-t border-gray-200 flex justify-end p-2 px-4">
							<button className="text-sm text-blue-500 hover:text-blue-700">
								Action
							</button>
						</div>
					</div>
				);
			} ) : null}
		</div>
	);
}

export default AlertsSidebarContent;
